import config from '../config'
import { authHeader } from './auth-header'

export const activityLogService = {

  /**
   * GET /api/activitylogs/all
   * @param {object} params - { limit, offset }
   */
  getAll(params = {}) {
    const qs = new URLSearchParams({
      limit:  params.limit  || 200,
      offset: params.offset || 0,
    }).toString()
    const requestOptions = {
      method: 'GET',
      headers: authHeader()
    }
    return fetch(`${config.apiUrl}/activitylogs/all?${qs}`, requestOptions)
      .then(handleResponse)
  },

  /**
   * GET /api/activitylogs/filter
   * @param {object} params - { userId, action, dateFrom, dateTo, limit, offset }
   */
  filter(params = {}) {
    const query = {}
    if (params.userId)   query.userId   = params.userId
    if (params.action)   query.action   = params.action
    if (params.dateFrom) query.dateFrom = params.dateFrom
    if (params.dateTo)   query.dateTo   = params.dateTo
    query.limit  = params.limit  || 200
    query.offset = params.offset || 0

    const qs = new URLSearchParams(query).toString()
    const requestOptions = {
      method: 'GET',
      headers: authHeader()
    }
    return fetch(`${config.apiUrl}/activitylogs/filter?${qs}`, requestOptions)
      .then(handleResponse)
  },

  /**
   * DELETE /api/activitylogs/purge
   * Triggers a manual purge of logs older than 30 days.
   */
  purge() {
    const requestOptions = {
      method: 'DELETE',
      headers: authHeader()
    }
    return fetch(`${config.apiUrl}/activitylogs/purge`, requestOptions)
      .then(handleResponse)
  }
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
